import { createPaginationParams } from 'APIPackage/MainModule/common/createPaginationParams';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';

import { ILegalBasisSearchParams } from '../interfaces/ILegalBasisSearchParams';
import { ILegalBasisDocument } from '../interfaces/ILegalBasisDocument';
import { ILegalBasisDocumentType } from '../interfaces/ILegalBasisDocumentType';
import { ILegalBasisLevel } from '../interfaces/ILegalBasisLevel';
import { IPageLegalBasisDocument } from '../interfaces/IPageLegalBasisDocument';

export async function fetchLegalBasisLevels(): Promise<ILegalBasisLevel[]> {
  return apiGet<ILegalBasisLevel[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/legal-basis/levels`);
}

export async function fetchLegalBasisTypes(): Promise<ILegalBasisDocumentType[]> {
  return apiGet<ILegalBasisDocumentType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/legal-basis/types`,
  );
}

export async function fetchLegalBasisSearch({
  pagination,
  ...filter
}: ILegalBasisSearchParams): Promise<IPageLegalBasisDocument> {
  const queryParams = pagination ? createPaginationParams(pagination) : '';

  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/legal-basis${
      queryParams ? `?${queryParams}` : ''
    }`,
    body: filter,
  });
}

export async function fetchLegalBasisFrequentlyUsed(count: number): Promise<ILegalBasisDocument[]> {
  return apiGet<ILegalBasisDocument[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/legal-basis/frequently-used?count=${count}`,
  );
}

export async function fetchLegalBasisFrequentlyUsedSave(externalIdList: Array<string>): Promise<void> {
  const queryParams = new URLSearchParams();

  externalIdList.forEach(externalId => queryParams.append('externalIdList', externalId));

  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/legal-basis/frequently-used${
      queryParams ? `?${queryParams}` : ''
    }`,
  });
}
